import {inject, injectable} from "inversify";
import {Player} from "@/modules/team/entity";
import WageCalculator from "@/modules/team/services/WageCalculator";
import chance from "@/modules/base/services/chance";

@injectable()
export class PlayerContractExtender {
  constructor(
    @inject(WageCalculator) private wageCalculator: WageCalculator,
  ) {
  }

  async can(player: Player) {
    return !player.team!.user && !player.endsCareer && !player.careerEndedAt;
  }

  async extend(player: Player): Promise<void> {
    player.contractYears = chance.integer({min: 2, max: 5});
    player.wage = this.wageCalculator.calculate(player);
    await player.save();
  }
}